import { trendData } from "@/mocks/celebrityData";

const stats = [
  { num: "1200+", label: "收录公开事件", icon: "ri-folder-2-line" },
  { num: "3000+", label: "图文内容", icon: "ri-file-text-line" },
  { num: "2400+", label: "现场视频", icon: "ri-vidicon-line" },
  { num: "800+", label: "深度长文", icon: "ri-article-line" },
];

export default function Trending() {
  return (
    <section id="trend" className="mx-auto max-w-7xl px-4 py-14 md:px-6" aria-label="热榜趋势">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
        {stats.map((s) => (
          <div
            key={s.label}
            className="flex items-center gap-4 rounded-2xl border border-paper-200 bg-paper-100 p-4 md:p-5"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-crimson-100 text-xl text-crimson-500">
              <i className={s.icon} aria-hidden="true"></i>
            </span>
            <div className="min-w-0">
              <p className="font-serif text-xl font-black text-ink-950 md:text-2xl">{s.num}</p>
              <p className="truncate text-xs text-ink-600 md:text-sm">{s.label}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 grid gap-10 lg:grid-cols-[1.1fr_1.6fr]">
        <div>
          <div className="flex items-center gap-3">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-crimson-500 text-white">
              <i className="ri-fire-line" aria-hidden="true"></i>
            </span>
            <div>
              <h2 className="font-serif text-2xl font-black text-ink-950">实时热搜榜</h2>
              <p className="text-xs text-ink-600">按公开讨论热度滚动更新</p>
            </div>
          </div>

          <div className="mt-6 space-y-2.5">
            {trendData.map((t) => (
              <div
                key={t.rank}
                className="group flex items-center gap-3 rounded-xl border border-paper-200 bg-white px-4 py-3 transition hover:border-amber2-100 hover:bg-gold-100/40"
              >
                <span
                  className={`font-serif text-xl font-black ${
                    t.rank <= 3 ? "text-crimson-500" : "text-ink-300"
                  }`}
                >
                  {String(t.rank).padStart(2, "0")}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-semibold text-ink-800">{t.keyword}</p>
                  <p className="text-xs text-ink-400">热度 {t.heat}</p>
                </div>
                <span
                  className={`flex shrink-0 items-center gap-0.5 text-xs font-medium ${
                    t.up ? "text-crimson-500" : "text-ink-400"
                  }`}
                >
                  <i
                    className={t.up ? "ri-arrow-up-line" : "ri-arrow-down-line"}
                    aria-hidden="true"
                  ></i>
                  {t.delta}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="relative flex flex-col justify-between overflow-hidden rounded-3xl border border-paper-200 bg-ink-950 p-7 text-white md:p-9">
          <img
            src="https://readdy.ai/api/search-image?query=backstage%20glamour%20of%20an%20award%20ceremony%20with%20golden%20trophy%20and%20spotlight%20rays%2C%20deep%20dark%20background%2C%20warm%20amber%20and%20crimson%20accent%20light%2C%20cinematic%20editorial&width=1000&height=1100&seq=hero-trend-panel&orientation=portrait"
            alt="盛典后台金光氛围"
            className="absolute inset-0 h-full w-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
          <div className="relative">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-amber2-500 px-3 py-1 text-xs font-semibold text-white">
              <i className="ri-capsule-line" aria-hidden="true"></i> 今日头条
            </span>
            <h3 className="mt-4 font-serif text-2xl font-black leading-snug md:text-3xl">
              周冉《长风渡口》杀青
              <br />
              幕后花絮全网热议
            </h3>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-white/80">
              历时四个月的拍摄收官，官方释出的幕后特辑登上话题榜首。我们为你串联从立项、开机到杀青的完整公开时间线，几分钟看完全程。
            </p>
            <a
              href="#news"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("news")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-gold-500 px-6 py-2.5 text-sm font-semibold text-white transition hover:bg-amber2-500"
            >
              看事件脉络
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}